<template lang="pug">
div()
    v-card.d-none.d-sm-block.mx-4.my-2.rounded-lg.elevation-25( v-for="(item, i) in videos" :key="`desktop-${item.id}`" )
              v-list-item(three-line)
                .videoThumbnail.rounded-lg(:style="{ backgroundImage: 'url(' + getThumbnailUrl(item.id, item.token, item.element) + ')' }")
                v-list-item-content
                  h2(v-html="highlightTitle(item.title)")
                  p(v-html="highlightDescription(item.description)")
                  v-list-item-subtitle
                    v-btn(
                      depressed
                      x-small,
                      color="accent",
                      v-if="item.element === 'CLIP'"
                      :disabled="item.status != VideoStatus.COMPLETED"
                      @click="addClipToTimeline({item, buttonOrigin})"
                    ) {{$t('search.add')}}
                    v-btn.ml-2(
                      depressed
                      x-small,
                      color="primary",
                      :disabled="item.status != VideoStatus.COMPLETED"
                      @click="displayMovie(item)"
                    ) {{$t('search.preview')}}
                    v-btn.ml-2(
                      v-if="item.element === 'CLIP'"
                      depressed
                      x-small,
                      color="primary",
                      :to="{name:'clip', params: {videoId: item.id }}"
                    ) {{$t('search.details')}}
                    v-btn.ml-2(
                      v-if="item.element === 'MOTION'"
                      depressed
                      x-small,
                      color="primary",
                      :to="{name:'motion', params: {videoId: item.id }}"
                    ) Details
                v-list-item-action
                  v-chip.mb-2(:color="item.element === 'MOTION' ? 'accent' : 'primary'" small) {{item.element === 'MOTION' ? "MOTION" : "CLIP"}}
                  VideoStatusIcons(:video="item")
    v-card.d-sm-none.d-block.mx-4.my-4.rounded-lg.elevation-25( v-for="(item, i) in videos" :key="`mobile-${item.id}`" )
      v-img(:src="getThumbnailUrl(item.id, item.token, item.element)")
      v-card-title(v-html="highlightTitle(item.title)")
      v-card-text(v-if="item.description" v-html="highlightDescription(item.description)")
      v-card-actions
        v-chip.mb-2(:color="item.element === 'MOTION' ? 'accent' : 'primary'" small) {{item.element === 'MOTION' ? "MOTION" : "CLIP"}}
        VideoStatusIcons(:video="item")
      v-card-actions  
        v-btn(
          depressed
          x-small,
          color="accent",
          v-if="item.element === 'CLIP'"
          :disabled="item.status != VideoStatus.COMPLETED"
          @click="addClipToTimeline({item, buttonOrigin})"
        ) {{$t('search.add')}}
        v-btn.ml-2(
          depressed
          x-small,
          color="primary",
          :disabled="item.status != VideoStatus.COMPLETED"
          @click="displayMovie(item)"
        ) {{$t('search.preview')}}
        v-btn.ml-2(
          v-if="item.element === 'CLIP'"
          depressed
          x-small,
          color="primary",
          :to="{name:'clip', params: {videoId: item.id }}"
        ) {{$t('search.details')}}
        v-btn.ml-2(
          v-if="item.element === 'MOTION'"
          depressed
          x-small,
          color="primary",
          :to="{name:'motion', params: {videoId: item.id }}"
        ) Details
</template>

<script>
import { VideoStatus } from "../../models";
import urlFormat from "@/utils/urlFormat";
import VideoStatusIcons from "@/components/video/VideoStatusIcons";
import { mapMutations } from "vuex";
export default {
  components: {
    VideoStatusIcons,
  },
  props: ["videos", "buttonOrigin"],
  data() {
    return {
      VideoStatus,
    };
  },
  methods: {
    ...urlFormat,
    highlightDescription(description) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      const query = queries.q;
      return description.replace(new RegExp(query, "gi"), (match) => {
        return '<span class="highlightText">' + match + "</span>";
      });
    },
    highlightTitle(title) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      const query = queries.q;
      return title.replace(new RegExp(query, "gi"), (match) => {
        return '<span class="highlightText">' + match + "</span>";
      });
    },
    displayMovie(item) {
      this.$store.commit("player/set_video_dialog", {
        visible: true,
        src: this.getVideoStreamUrl(item.id, item.token),
        token: item.token,
        element: item.element,
      });
    },
    ...mapMutations("create", {
      addClipToTimeline: "add_element_to_timeline",
    }),
  },
};
</script>
<style lang="sass">
@import '@/assets/style/variables'
.videoThumbnail
  height: 100px
  width: 177.77px
  object-fit: cover
  margin: 12px 24px 12px 0
  background-size: cover
  background-repeat: no-repeat
  background-color: $primary
h2
  font-size: 1.2rem
  font-weight: 500
p, h2
  // font-weight: 300
  span.highlightText
    // color: white
    background: #eee
    // font-weight: 700
</style>
